module.exports = __webpack_public_path__ + "static/img/facebook.dd2f7c59.svg";